import {useTranslation} from "react-i18next";

const SellProperty = () => {

    const {t} = useTranslation();

    return (
        <>
            <div>
                <h4>{t("serviceDetailPage.vendita-immobili.title")}</h4>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.vendita-immobili.contentText1") as string}}></p>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.vendita-immobili.contentText2") as string}}></p>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.vendita-immobili.contentText3") as string}}></p>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.vendita-immobili.contentText4") as string}}></p>
            </div>
            <div>
                <h4>{t("serviceDetailPage.vendita-immobili.contentTitle2")}</h4>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.vendita-immobili.contentText5") as string}}></p>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.vendita-immobili.contentText6") as string}}></p>
                <ul>
                    <li>{t("serviceDetailPage.vendita-immobili.listItem1")}</li>
                    <li>{t("serviceDetailPage.vendita-immobili.listItem2")}</li>
                    <li>{t("serviceDetailPage.vendita-immobili.listItem3")}</li>
                    <li>{t("serviceDetailPage.vendita-immobili.listItem4")}</li>
                    <li>{t("serviceDetailPage.vendita-immobili.listItem5")}</li>
                    <li>{t("serviceDetailPage.vendita-immobili.listItem6")}</li>
                    <li>{t("serviceDetailPage.vendita-immobili.listItem7")}</li>
                    <li>{t("serviceDetailPage.vendita-immobili.listItem8")}</li>
                    <li>{t("serviceDetailPage.vendita-immobili.listItem9")}</li>
                    <li>{t("serviceDetailPage.vendita-immobili.listItem10")}</li>
                </ul>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.vendita-immobili.contentText7") as string}}></p>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.vendita-immobili.contentText8") as string}}></p>
            </div>
            <div>
                <h4>{t("serviceDetailPage.vendita-immobili.contentTitle3")}</h4>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.vendita-immobili.contentText9") as string}}></p>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.vendita-immobili.contentText10") as string}}></p>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.vendita-immobili.contentText11") as string}}></p>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.vendita-immobili.contentText12") as string}}></p>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.vendita-immobili.contentText13") as string}}></p>
                <p dangerouslySetInnerHTML={{__html: t("serviceDetailPage.vendita-immobili.contentText14") as string}}></p>
            </div>
        </>
    )
}

export default SellProperty;